import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['fieldset']

  change (e) {
    this.fieldsetTargets.forEach((fieldset) => {
      fieldset.setAttribute('hidden', '')
      fieldset.setAttribute('disabled', '')
    })
    
    const fieldset = document.getElementById(e.target.dataset.toggleTarget)
    if (e.target.checked) {
      fieldset.removeAttribute('hidden')
      fieldset.removeAttribute('disabled')
    }
  }
}
